import axios from "axios";
import Links from "@/shared/constants/Links";

const Convocation = {
    createYear: (data) => axios.post(Links.convocation.years, {
        yearLabel: data.yearLabel,
        description: data.description,
        active: data.active,
    }),

    listYears: () => axios.get(Links.convocation.years),

    uploadCSV: (yearId, file) => {
        const formData = new FormData();
        formData.append('file', file);
        return axios.post(Links.convocation.yearUpload + yearId + '/upload', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },

    getRecords: (yearId, page, size) => axios.get(
        Links.convocation.yearRecords + yearId + '/records',
        { params: { page, size } }
    ),

    getSettings: () => axios.get(Links.convocation.settings),

    updateSettings: (data) => axios.put(Links.convocation.settings, {
        amount: data.amount,
        defaultPaymentPlatform: data.defaultPaymentPlatform,
        serviceId: data.serviceId,
        enabled: data.enabled,
    }),

    publicYears: () => axios.get(Links.convocation.publicYears),

    publicRecords: (yearId, page, size) => axios.get(
        Links.convocation.publicRecords + yearId + '/records',
        { params: { page, size } }
    ),

    searchByMatric: (yearId, matric, page, size) => axios.get(
        Links.convocation.publicSearch + yearId + '/records/search',
        { params: { matric, page, size } }
    ),

    initializePayment: (data) => axios.post(Links.convocation.publicPaymentInit, {
        matric: data.matric,
        yearId: data.yearId,
    }),

    verifyPayment: (reference) => axios.post(Links.convocation.publicPaymentVerify, { reference }),
};

export default Convocation;
